<template>
    <div class="oc-file-upload-box">
        <span class="btn btn-info fileinput-button" v-class="btnClasses">
            <oc-icon :type="btnIcon" v-if="btnIcon" />

            <span>{{btnText}}</span>

            <input ref="fileInput" class="file-input" type="file" :multiple="multiple" v-bind="inputOptions" />
        </span>

        <div class="progress rounded-0" v-show="displayProgress" :style="{height: progress == 0 ? 0 : '14px'}">
            <div class="progress-bar progress-bar-striped" :class="[progressError ? 'bg-danger' : 'bg-success']" v-class="progressBarClasses" :style="{width: progress + '%'}">
                <template v-if="progress > 0">
                    {{progress}}%
                </template>
            </div>
        </div>
    </div>
</template>

<script>
// https://github.com/blueimp/jQuery-File-Upload/wiki/Options

export default {
    name: 'oc-jquery-file-upload',
    props: {
        id: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        displayProgress: {
            type: Boolean,
            default: true
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        maxChunkSize: {
            type: Number,
            default: 0 // no chunk upload
        },
        name: {
            type: String,
            default: 'file'
        },
        btnText: {
            type: String,
            default: 'Select files...'
        },
        btnIcon: {
            type: String,
            default: 'upload'
        },
        btnClasses: {
            type: [Object, Array, String],
            default: () => []
        },
        progressBarClasses: {
            type: [Object, Array, String],
            default: () => []
        },
        formData: {
            type: [Object, Function],
            default: () => ({})
        },
        pluginOptions: {
            type: Object,
            default: () => ({})
        },
        inputOptions: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            progress: 0,
            progressError: false
        }
    },
    mounted() {

        // Demo: https://blueimp.github.io/jQuery-File-Upload/
        // Options: https://github.com/blueimp/jQuery-File-Upload/wiki/Options
        let vm = this
        let url = this.url

        $(vm.$refs.fileInput).prop('disabled', !$.support.fileInput)
            .parent().addClass($.support.fileInput ? undefined : 'disabled')

        let options = {
            url,
            dataType: 'json',
            maxChunkSize: vm.maxChunkSize, // 1 MB
            singleFileUploads: true, // it is important to send the files in separate XHR requests
            paramName: this.name,
            sequentialUploads: true,
            autoUpload: this.autoUpload
        }

        options = Object.assign(options, vm.pluginOptions)

        let uploader = $(vm.$refs.fileInput).fileupload(options)

        uploader.on("fileuploadprogressall", function (e, data) {
            if( vm.displayProgress ) {
                vm.progress = parseInt(data.loaded / data.total * 100, 10)
            }

            vm.$emit('fileuploadprogressall', e, data)
        })

        uploader.on("fileuploaddone", function(e, data) {
            vm.$emit('fileuploaddone', e, data)

            if( vm.displayProgress ) {
                if( data.result && data.result.status === 'error' ) {
                    vm.progressError = true
                }

                setTimeout(() => {
                    vm.progress = 0
                    vm.progressError = false
                }, 3000)
            }
        })

        uploader.on("fileuploadadd", function(e, data) {
            if( vm.displayProgress ) {
                vm.progress = 0
            }

            data.formData = typeOf(vm.formData) === 'function' ? vm.formData() : vm.formData

            vm.$emit('fileuploadadd', e, data)
        })
        uploader.on("fileuploadstart", function(e, data) {
            vm.$emit('fileuploadstart', e, data)
        })
        uploader.on("fileuploadfail", function(e, data) {
            if( vm.displayProgress ) {
                vm.progressError = true

                setTimeout(() => {
                    vm.progress = 0
                    vm.progressError = false
                }, 3000)
            }

            vm.$emit('fileuploadfail', e, data)
        })
        uploader.on("fileuploadchange", function(e, data) {
            vm.$emit('fileuploadchange', e, data)
        })

        // chunk events

        uploader.on('fileuploadchunkbeforesend', function (e, data) {
            vm.$emit('fileuploadchunkbeforesend', e, data)
        })
        uploader.on('fileuploadchunksend', function (e, data) {
            vm.$emit('fileuploadchunksend', e, data)
        })
        uploader.on('fileuploadchunkdone', function (e, data) {
            vm.$emit('fileuploadchunkdone', e, data)
        })
        uploader.on('fileuploadchunkfail', function (e, data) {
            vm.$emit('fileuploadchunkfail', e, data)
        })
        uploader.on('fileuploadchunkalways', function (e, data) {
            vm.$emit('fileuploadchunkalways', e, data)
        });
    }
}
</script>

<style>
    .oc-file-upload-box {
        margin:0;
    }

    .oc-file-upload-box .progress {
        height: 14px;
        font-size:10px;
    }

    .oc-file-upload-box .progress .progress-bar {
        margin-top: 2px;
    }

    .oc-file-upload-box .fileinput-button {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }

    .oc-file-upload-box .fileinput-button input {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
        opacity: 0;
        -ms-filter: 'alpha(opacity=0)';
        font-size: 200px !important;
        direction: ltr;
        cursor: pointer;
    }

    /* Fixes for IE < 8 */
    @media screen\9 {
        .oc-file-upload-box .fileinput-button input {
            filter: alpha(opacity=0);
            font-size: 100%;
            height: 100%;
        }
    }
</style>
